var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contact-info"},[_c('small',[_c('div',[_vm._v("Customer Support")]),_c('div',[_c('a',{attrs:{"href":"mailto:support@twiagemed.com"}},[_vm._v("support@twiagemed.com")])]),_c('div',[_c('a',{attrs:{"href":"tel:888 589 4243"}},[_vm._v("(888) 589-4243")])]),_c('div',[_c('a',{attrs:{"href":"tel:646 968 0204"}},[_vm._v("(646) 968-0204")])])])])
}]

export { render, staticRenderFns }